import { VDirective } from '@libTs/vue-base';

export const FirstDirective: VDirective = [
  'first',
  {
    bind( el: HTMLElement ): void {
      $( function () {
        const firstEl = el.firstChild?.firstChild as HTMLElement;

        firstEl.classList.add( 'first-el' );
      } );
    },
  },
];